import { render, staticRenderFns } from "./WorkTableChips.vue?vue&type=template&id=1ff86812&scoped=true"
import script from "./WorkTableChips.vue?vue&type=script&lang=js"
export * from "./WorkTableChips.vue?vue&type=script&lang=js"
import style0 from "./WorkTableChips.vue?vue&type=style&index=0&id=1ff86812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff86812",
  null
  
)

export default component.exports